import { Button } from '@bfe/moly';
import { AccountIcon } from '@bfe/moly-icons';
import React, { FC, useMemo } from 'react';

import AccountBasicItem from '@/components/AccountBasicItem';
import { SecuritySettingModalNames } from '@/components/SecuritySettingModalManager';
import { useUserProfile } from '@/hooks/useUserProfile';
import { useI18nContext } from '@/i18n/I18n';
import { useSecuritySettingModal } from '@/store/useSecuritySettingModal/useSecuritySettingModal';
import { useStore } from '@/store/useStore';

export const LEVELS = {
  levelDefault: 0,
  level1: 1,
  level2: 2,
  level3: 3,
};

export interface IKyc {
  opened: boolean | undefined;
  applicant: {
    level: string;
  };
}

const KycAuth: FC = () => {
  const { profile } = useUserProfile();
  const { kyc } = useStore();
  const [$t] = useI18nContext();

  const { openSecuritySettingModal } = useSecuritySettingModal();

  const level = useMemo(() => {
    const isEnterprise =
      profile?.result?.member_tag &&
      profile?.result?.member_tag.KYC &&
      profile?.result?.member_tag.KYC === '1';
    if (isEnterprise) return LEVELS.level3;
    const levels: { [key: string]: number } = {
      LEVEL_DEFAULT: LEVELS.levelDefault,
      LEVEL_1: LEVELS.level1,
      LEVEL_2: LEVELS.level2,
    };

    return levels[kyc?.applicant?.level] || LEVELS.levelDefault;
  }, [profile, kyc]);

  const linkKycLevel = () => {
    openSecuritySettingModal(SecuritySettingModalNames.Kyc);
  };

  return (
    <>
      {kyc.opened !== false && (
        <AccountBasicItem
          icon="kyc"
          molyIcon={<AccountIcon />}
          text={$t('kycAuth')}
          subText={
            <>
              {level === LEVELS.levelDefault && (
                <>
                  <div className="accountInfo-auth-container-content-last">
                    <span className="not-set-text text-special-color">
                      {$t('kycCompleteAuthIncreaseLimit')}
                    </span>
                  </div>
                </>
              )}
            </>
          }
          status={!!level}
          statusNode={
            <>
              {level === LEVELS.levelDefault && <> {$t('kycNotCertified')}</>}
              {level === LEVELS.level1 && <>{$t('kycVerified')} Lv.1</>}
              {level === LEVELS.level2 && <>{$t('kycVerified')} Lv.2</>}
              {level === LEVELS.level3 && (
                <>{$t('kycCompleteEnterpriseCertification')}</>
              )}
            </>
          }
          operation={
            <>
              {level === LEVELS.levelDefault || level === LEVELS.level1 ? (
                <Button
                  size="small"
                  data-radius="small"
                  variant="primary"
                  onClick={linkKycLevel}
                >
                  {$t('kycCertification')}
                </Button>
              ) : (
                <></>
              )}
              {(level === LEVELS.level2 || level === LEVELS.level3) && (
                <Button
                  size="small"
                  data-radius="small"
                  variant="secondary"
                  onClick={linkKycLevel}
                >
                  {$t('kycView')}
                </Button>
              )}
            </>
          }
        />
      )}
    </>
  );
};
export default KycAuth;
